export default __webpack_public_path__ + "static/media/dvd.5e861465.jpg";